var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.913,
    height: 71.913,
    viewBox: "0 0 71.913 71.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon_simple-sass"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-sass-2",
    "data-name": "Icon simple-sass",
    d: "M35.957,0A35.957,35.957,0,1,1,0,35.957,35.958,35.958,0,0,1,35.957,0ZM28.81,47.936a9.189,9.189,0,0,1-.072,5.37l-.195.539c-.072.183-.156.36-.234.527A10.08,10.08,0,0,1,26.647,56.8c-2.091,2.274-5.01,3.137-6.262,2.412-1.348-.785-.677-4,1.75-6.562a24.463,24.463,0,0,1,6.352-4.522v-.009l.324-.183Zm29.7-32.544C56.883,9,46.291,6.9,36.268,10.463c-5.96,2.118-12.417,5.447-17.058,9.789-5.522,5.157-6.4,9.651-6.038,11.53,1.279,6.625,10.359,10.958,14.092,14.173v.018c-1.1.539-9.157,4.581-11.045,8.764-2.023,4.4.315,7.554,1.843,7.955,4.719,1.306,9.573-1.079,12.18-4.941a12.428,12.428,0,0,0,1.211-11.015,13.981,13.981,0,0,1,5.483-.312c6.3.719,7.554,4.674,7.281,6.292a4.321,4.321,0,0,1-2.02,2.829c-.449.273-.584.36-.542.542.045.27.273.27.629.225A4.985,4.985,0,0,0,45.7,51.906c.135-3.865-3.554-8.177-10.113-8.09a16.206,16.206,0,0,0-5.618.767,1.086,1.086,0,0,0-.315-.315c-4.045-4.36-11.551-7.416-11.236-13.214.09-2.112.854-7.683,14.383-14.425,11.1-5.531,19.959-4,21.487-.629,2.2,4.806-4.722,13.753-16.273,15.054-4.4.494-6.7-1.211-7.284-1.843-.626-.674-.716-.719-.941-.581-.36.18-.135.764,0,1.124a6.919,6.919,0,0,0,4.183,3.281c2.109.674,7.281,1.076,13.484-1.348,6.964-2.694,12.4-10.2,10.829-16.5l.219.2Z",
    fill: "#006151"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_simple-sass)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-sass-3",
    "data-name": "Icon simple-sass",
    d: "M35.957,0A35.957,35.957,0,1,1,0,35.957,35.958,35.958,0,0,1,35.957,0ZM28.81,47.936a9.189,9.189,0,0,1-.072,5.37l-.195.539c-.072.183-.156.36-.234.527A10.08,10.08,0,0,1,26.647,56.8c-2.091,2.274-5.01,3.137-6.262,2.412-1.348-.785-.677-4,1.75-6.562a24.463,24.463,0,0,1,6.352-4.522v-.009l.324-.183Zm29.7-32.544C56.883,9,46.291,6.9,36.268,10.463c-5.96,2.118-12.417,5.447-17.058,9.789-5.522,5.157-6.4,9.651-6.038,11.53,1.279,6.625,10.359,10.958,14.092,14.173v.018c-1.1.539-9.157,4.581-11.045,8.764-2.023,4.4.315,7.554,1.843,7.955,4.719,1.306,9.573-1.079,12.18-4.941a12.428,12.428,0,0,0,1.211-11.015,13.981,13.981,0,0,1,5.483-.312c6.3.719,7.554,4.674,7.281,6.292a4.321,4.321,0,0,1-2.02,2.829c-.449.273-.584.36-.542.542.045.27.273.27.629.225A4.985,4.985,0,0,0,45.7,51.906c.135-3.865-3.554-8.177-10.113-8.09a16.206,16.206,0,0,0-5.618.767,1.086,1.086,0,0,0-.315-.315c-4.045-4.36-11.551-7.416-11.236-13.214.09-2.112.854-7.683,14.383-14.425,11.1-5.531,19.959-4,21.487-.629,2.2,4.806-4.722,13.753-16.273,15.054-4.4.494-6.7-1.211-7.284-1.843-.626-.674-.716-.719-.941-.581-.36.18-.135.764,0,1.124a6.919,6.919,0,0,0,4.183,3.281c2.109.674,7.281,1.076,13.484-1.348,6.964-2.694,12.4-10.2,10.829-16.5l.219.2Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScss);
export default __webpack_public_path__ + "static/media/scss.9d4f5bab714db1bfd5d84a30a80f86e0.svg";
export { ForwardRef as ReactComponent };